import React, { useState, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { ContentType } from "../../../../../../common/interfaces/flow/action/WebRequestAction";
import { updateHeader, safeCreateIfEmptyHeaders, getHeaderValueByKey } from "../../../../../../common/utils/header.util";
const items = [
  {
    key: ContentType.JSON,
    label: ContentType.JSON,
  },
  {
    key: ContentType.XML,
    label: ContentType.XML,
  },
  {
    key: ContentType.TEXT,
    label: ContentType.TEXT,
  },
];

const isBody = (contentType) => {
  return (
    contentType === null ||
    contentType === undefined ||
    contentType === ContentType.JSON ||
    contentType === ContentType.XML ||
    contentType === ContentType.TEXT
  );
};

const ContentTypes = ({ updateCallback, action }) => {
  const [value, setValue] = useState(ContentType.RAW);
  const [type, setType] = useState(ContentType.JSON);

  useEffect(() => {
    if (action) {
      const value = getHeaderValueByKey(action?.headers, "Content-Type");
      if (isBody(value)) {
        setType(value || ContentType.JSON);
        setValue(ContentType.RAW);
      } else {
        setValue(value);
      }
    }
  }, [action]);

  const onChange = (e) => {
    setValue(e.target.value);
    safeCreateIfEmptyHeaders(action);
    if (e.target.value === ContentType.RAW) {
      updateHeader(action.headers, "Content-Type", type);
    } else {
      updateHeader(action.headers, "Content-Type", e.target.value);
    }
    updateCallback();
  };
  const onClick = ({ key }) => {
    setType(key);
    safeCreateIfEmptyHeaders(action);
    updateHeader(action.headers, "Content-Type", key);
    updateCallback();
  };
  const contentType = getHeaderValueByKey(action?.headers, "Content-Type");
  const showTypeBtn = isBody(contentType);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <label style={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
          <input type="radio" name="request-type" value={ContentType.RAW} checked={value === ContentType.RAW} onChange={onChange} />
          <span style={{ position: "relative", top: -1 }}>body</span>
        </label>
        {showTypeBtn && (
          <Dropdown menu={{ items, onClick }}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                {type}
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        )}
        <label style={{ marginLeft: 12, display: "inline-flex", alignItems: "center", gap: 1 }}>
          <input
            type="radio"
            name="request-type"
            value={ContentType.FORM_DATA}
            checked={value === ContentType.FORM_DATA}
            onChange={onChange}
          />
          <span style={{ position: "relative", top: -1 }}>form-data</span>
        </label>
        <label style={{ marginLeft: 12, display: "inline-flex", alignItems: "center", gap: 1 }}>
          <input
            type="radio"
            name="request-type"
            value={ContentType.X_WWW_FORM_URLENCODED}
            checked={value === ContentType.X_WWW_FORM_URLENCODED}
            onChange={onChange}
          />
          <span style={{ position: "relative", top: -1 }}>x-www-form-urlencoded</span>
        </label>
      </div>
    </>
  );
};
export default ContentTypes;
